import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const holdTypesAdapter = getAdapter({ idFieldName: 'value' });

const holdTypesSlice = createSlice({
  name: 'holdTypes',
  initialState: holdTypesAdapter.getInitialState(),
  reducers: {
    setHoldTypes: (state, { payload: { holdTypes } }) => {
      holdTypesAdapter.setAll(state, holdTypes);
    },
  },
});

const selectors = holdTypesAdapter.getSelectors(({ holdTypes }) => holdTypes);

export const getHoldTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getHoldTypes = (state) => getHoldTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setHoldTypes,
} = holdTypesSlice.actions;

export default holdTypesSlice.reducer;
